import React from 'react'
import { observer } from 'mobx-react'
import Input from '../generic/Input'
import FormRenderer from '../generic/FormRenderer'
import Button from '../generic/Button'
import { inject } from 'mobx-react'

const LoginForm = inject('loginStore')(observer((props) => {
  const { loginStore } = props
  const { email, password, isAuthenticating } = loginStore.user
  const loginFields = [
    {
      component: Input,
      label: 'E-mail',
      type: 'email',
      name: 'email',
      id: 'login-email',
      value: email,
      placeholder: 'E-mail'
    },
    {
      component: Input,
      label: 'Senha',
      type: 'password',
      name: 'password',
      id: 'login-password',
      value: password,
      placeholder: 'Senha'
    },
    {
      component: Button,
      text: 'Login',
      type: 'submit',
      onClick: event => loginStore.authenticate(event),
      id: 'login-submit',
      isLoading: isAuthenticating,
      styleClass: 'app-main-button'
    }
  ]

  return (
    <form>
      <FormRenderer fields={loginFields} store={loginStore} />
    </form>
  )
}))

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js